var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElAlert',{attrs:{"effect":"dark","show-icon":"","type":"warning"}},[_vm._v("\n  "+_vm._s(_vm.$t('ADVERTISEMENT.CAMPAIGN_VIEW.ADD_KEYWORD_HINT_DESCRIPTION'))+"\n  "),(!_vm.isOnCampaignKeywordsRoute)?_c('RouterLink',{attrs:{"to":{ name: 'search-ads-campaign-bids' }}},[_vm._v("\n    "+_vm._s(_vm.$t('ADVERTISEMENT.ADD_BID'))+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }